export default __webpack_public_path__ + "static/media/IMG_7232.801c6de4.jpg";